<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M11.124 1.05078V4.60634C11.124 5.26056 10.593 5.79152 9.9388 5.79152H5.79065C5.13643 5.79152 4.60547 5.26056 4.60547 4.60634V1.05078"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.60547 17.0525V11.1266C4.60547 10.4724 5.13643 9.94141 5.79065 9.94141H12.3092C12.9634 9.94141 13.4944 10.4724 13.4944 11.1266V17.0525"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.4898 17.0508H3.6098C2.19588 17.0508 1.0498 15.9047 1.0498 14.4908V3.61078C1.0498 2.19686 2.19588 1.05078 3.6098 1.05078H12.411C12.7251 1.05078 13.0273 1.17523 13.2489 1.39804L16.7025 4.85167C16.9254 5.07448 17.0498 5.37552 17.0498 5.6896V14.4908C17.0498 15.9047 15.9037 17.0508 14.4898 17.0508Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
